import React from 'react';
import iconPath from "../../../helpers/iconHelper";
import { getlanguagelist } from "../../../helpers/changelanguage";


export default function SimplePopover(props) {
    let  languagelist = getlanguagelist();
    $('.live_friend_list').scroll(function() {
        if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) { 
           // alert('End of DIV is reached!'); 
           props.onScroll();
        } 
    });
    const onSearch = ()=>{
        props.onSearch($('#search_'+props.type).val())
    }
    return (
      <div className="tag_list" style={{display : `${props.openpop}`}}>
        <input type="text" name="search" id={`search_${props.type}`} placeholder={languagelist.search} onKeyUp={onSearch}/>
        <ul className="live_friend_list">
            <li></li>
            {
                props.userfriendlist.map ((user,index) => {
                    return (
                        <li key={`li_${props.type}_${index}`}>
                            <div className="list_ico">
                            <img src={user.image} 
                            onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER']
                            }} 
                            /></div>
                            <div className="list_details">
                                <h4>
                                    <input type="checkbox" id={`user_${props.type}_${user.id}`} checked={props.checkedUser.includes(user.id) ? true : false } onChange={()=>props.doChange(user.id,user.full_name)}/> {user.full_name}
                                </h4>  
                            </div>
                            <div className="clearfix"></div>
                        </li>
                    )
                    
                })
            }
        </ul>
    </div>
  );
}